var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1003_500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36.9474,
    height: 36,
    rx: 15.8897,
    fill: "#FFDDFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42777,
    y: 1.42777,
    width: 36.0918,
    height: 35.1445,
    rx: 15.462,
    stroke: "url(#paint0_linear_1003_500)",
    strokeWidth: 0.855532
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4741 14.5989L19.0691 14.9889C19.1216 15.0433 19.1845 15.0866 19.2541 15.1162C19.3237 15.1458 19.3985 15.161 19.4741 15.161C19.5497 15.161 19.6246 15.1458 19.6942 15.1162C19.7637 15.0866 19.8266 15.0433 19.8791 14.9889L19.4741 14.5989ZM15.7249 22.7889C15.6095 22.694 15.4612 22.6488 15.3125 22.6633C15.1638 22.6778 15.027 22.7507 14.9321 22.8661C14.8372 22.9815 14.7921 23.1298 14.8066 23.2785C14.821 23.4272 14.894 23.564 15.0094 23.6589L15.7249 22.7889ZM12.2306 20.5321C12.2661 20.5969 12.314 20.6541 12.3715 20.7004C12.4291 20.7467 12.4952 20.7812 12.5661 20.802C12.637 20.8227 12.7113 20.8293 12.7847 20.8214C12.8582 20.8134 12.9293 20.7911 12.9941 20.7556C13.0589 20.7202 13.1161 20.6723 13.1624 20.6147C13.2087 20.5572 13.2432 20.4911 13.264 20.4202C13.2848 20.3493 13.2913 20.275 13.2834 20.2015C13.2754 20.1281 13.2531 20.0569 13.2176 19.9921L12.2306 20.5321ZM12.5366 17.3266C12.5366 15.7141 13.4479 14.3611 14.6921 13.7919C15.9011 13.2391 17.5256 13.3854 19.0691 14.9889L19.8791 14.2096C18.0491 12.3069 15.9221 11.9926 14.2241 12.7689C12.5636 13.5286 11.4116 15.2926 11.4116 17.3266H12.5366ZM16.8469 25.0989C17.2316 25.4019 17.6441 25.7244 18.0619 25.9689C18.4796 26.2126 18.9566 26.4114 19.4741 26.4114V25.2864C19.2416 25.2864 18.9686 25.1964 18.6296 24.9976C18.2899 24.7996 17.9381 24.5266 17.5436 24.2154L16.8469 25.0989ZM22.1014 25.0989C23.1709 24.2551 24.5389 23.2891 25.6114 22.0809C26.7041 20.8509 27.5366 19.3261 27.5366 17.3266H26.4116C26.4116 18.9751 25.7366 20.2449 24.7706 21.3339C23.7844 22.4439 22.5416 23.3191 21.4046 24.2154L22.1014 25.0989ZM27.5366 17.3266C27.5366 15.2926 26.3854 13.5286 24.7241 12.7689C23.0261 11.9926 20.9006 12.3069 19.0691 14.2089L19.8791 14.9889C21.4226 13.3861 23.0471 13.2391 24.2561 13.7919C25.5004 14.3611 26.4116 15.7134 26.4116 17.3266H27.5366ZM21.4046 24.2154C21.0101 24.5266 20.6584 24.7996 20.3186 24.9976C19.9796 25.1956 19.7066 25.2864 19.4741 25.2864V26.4114C19.9916 26.4114 20.4686 26.2126 20.8864 25.9689C21.3049 25.7244 21.7166 25.4019 22.1014 25.0989L21.4046 24.2154ZM17.5436 24.2154C16.9466 23.7451 16.3399 23.2951 15.7249 22.7889L15.0094 23.6589C15.6319 24.1711 16.2904 24.6601 16.8469 25.0989L17.5436 24.2154ZM13.2176 19.9929C12.7658 19.1772 12.5313 18.259 12.5366 17.3266H11.4116C11.4116 18.5551 11.7266 19.6104 12.2306 20.5321L13.2176 19.9929Z",
    fill: "#FF63C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.219 17.1988C11.219 21.2131 14.5374 23.3519 16.966 25.267C17.8228 25.9422 18.6483 26.5787 19.4738 26.5787C20.2992 26.5787 21.1247 25.9431 21.9816 25.2662C24.4109 23.3527 27.7285 21.2131 27.7285 17.1996C27.7285 13.1853 23.1884 10.3383 19.4738 14.1982C15.7591 10.3374 11.219 13.1845 11.219 17.1988Z",
    fill: "#FF63C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1003_500",
    x: 0.621053,
    y: 0.621053,
    width: 37.7052,
    height: 36.7579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.189474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1003_500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1003_500",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_500",
    x1: 22.6789,
    y1: 37,
    x2: 12.1928,
    y2: 6.93243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F740B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F881DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.0cffb0ff8d277decb84f898fb2937b3f.svg";
export { ForwardRef as ReactComponent };